import React, { useContext, useEffect, useState } from "react";
import { AnalisisCreditoContext } from "../AnalisisCreditoScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { ModalSolicitudCredito } from "../Modales/ModalSolicitudCredito";
import MdlSolicitudCreditoScreen from "../Modales/MdlSolicitudCreditoScreen";
import TimeLineTarget from "../TimeLine/TimeLineTarget";
import { AnalisisComentariosLine } from "../AnalisisComentariosLine";
import ComputerIcon from "@mui/icons-material/Computer";
import { CargarDocumentacionAsesor } from "../CreditoMhusa/CargarDocumentacionAsesor";
import { MhusaCargarPAgareEquip } from "../CreditoMhusa/MhusaCargarPAgareEquip";
import { MhusaFinalizacion } from "../CreditoMhusa/MhusaFinalizacion";
import CommentIcon from "@mui/icons-material/Comment";
import TimelineIcon from "@mui/icons-material/Timeline";
import { ModalComentariosJDF } from "../JDF-Condicionado/Modales/ModalComentariosJDF";
import { CargarDocumentacionVendedor } from "../../Credito/CreditoCondicionado/CargarDcoumentacionVendedor";
import { ValidarCondicionesOperacionCondicionadaJDF } from "../JDF-Condicionado/ValidarCondicionesOperacionCondicionadaJDF";
import FacturarEquipoCondicionado from "../../Credito/CreditoCondicionado/FacturarEquipoCondicionado";
import { CargarPagareEquipCondicionado } from "../../Credito/CreditoCondicionado/CargarPagareEquipCondicionado";
import { CargarDocumentacionAprobadaCondicionado } from "../../Credito/CreditoCondicionado/CargarDocumentacionAprobadaCondicionado";
import { AnalizarDocumentacionAprobadaCondicionado } from "../../Credito/CreditoCondicionado/AnalizarDocumentacionAprobadaCondicionado";
import { FinalizarSolicitudCreditoCondicionado } from "../../Credito/CreditoCondicionado/FinalizarSolicitudCreditoCondicionado";
import { CargarDocumentacionReestructuracion } from "../ReestructuracionSolicitudCredito/CargarDocumentacionReestructuracion";
import { ReestructuracionFinalizarSolicitud } from "../ReestructuracionSolicitudCredito/ReestructuracionFinalizarSolicitud";
import { obtenerPasosHabilitados } from "../../../Helpers/TimelineHelper";


export const ReestructuracionSolicitudCredito = ({ data, estado, upload, direccion }) => {
    const { state } = useContext(AnalisisCreditoContext);
    const [openSolicitud, setOpenSolicitud] = useState(false);
    const [mostrarCondicionado, setMostrarCondicionado] = useState(false);
    const [mostrarComentarios, setMostrarComentarios] = useState(false);
    const [rechazoCondicionado, setRechazoCondicionado] = useState(false);
    const [valueCondicionado, setValueCondicionado] = useState(0);
    const [openSolicitudCondicionado, setOpenSolicitudCondicionado] =
        useState(false);
    const [comentarios, setComentario] = useState([]);
    const [dataCondicionado, setDataCondicionado] = useState({
        estado: {},
        detalle: [],
    });
    const [value, setValue] = useState(0);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    useEffect(() => {
        onActualizarComentarios();
    }, []);

    const onActualizarComentarios = () => {
        if (
            state.folio === undefined ||
            state.folio === null ||
            state.folio.length !== 13
        ) {
            return;
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setComentario(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
            });
    };


    // Función para manejar la apertura de precalificacion
    const handleOpenComentarios = () => {
        setMostrarComentarios(true);
    };

    // Función para manejar el cierre de MdlValidacionPedidoJDF
    const handleCloseComentarios = () => {
        setMostrarComentarios(false);
    };

    return (
        <PlantillaScreen
            titulo={"PROCESO DE SOLICITUD DE CREDITO DE LINEA POR OPERACION"}
            className={"analisis-sc-procesos"}
        >
            <LoaderScreen loader={loader} />
            {mostrarComentarios && (
                <ModalComentariosJDF
                    setOpenSolicitud={handleCloseComentarios}
                    titulo={"COMENTARIOS"}
                    estado={estado}
                    comentarios={comentarios}
                />
            )}
            <ModalSolicitudCredito
                open={openSolicitud}
                setOpenSolicitud={setOpenSolicitud}
                value={value}
                setValue={setValue}
                upload={upload}
                maxValue={Number(estado.pantallacompleta)}
                pasosHabilitados={obtenerPasosHabilitados(data)}

                screens={{
                    screen0: (
                        <MdlSolicitudCreditoScreen
                            folio={state.folio}
                            setLoader={setLoader}
                            loader={loader}
                        />
                    ),
                    screen1: (
                        <CargarDocumentacionReestructuracion
                            folio={state.folio}
                            setLoader={setLoader}
                            loader={loader}
                            updateComentarios={onActualizarComentarios}
                        />
                    ),
                    screen2: (
                        <MhusaCargarPAgareEquip
                            folio={state.folio}
                            setLoader={setLoader}
                            loader={loader}
                        />
                    ),
                    screen3: (
                        <ReestructuracionFinalizarSolicitud
                            folio={state.folio}
                            setLoader={setLoader}
                            loader={loader}
                        />
                    ),
                }}
                titulos={{
                    screen0: "SOLICITUD DE CREDITO",
                    screen1: "CARGAR PAGARE",
                    screen2: "CAPTURAR INFORMACION EQUIP",
                    screen3: "FINALIZAR SOLICITUD",
                }}
            />

            <div className="analisis-sc-procesos-timeline-header-container">
                <div className="analisis-sc-procesos-timeline-title-condicionado ">
                    {state.cliente}
                </div>
            </div>

            <div className="analisis-sc-procesos-timeline scroll">
                <TimeLineTarget
                    icon={<ComputerIcon />}
                    title={"Genero Solicitud"}
                    subtitle={"Vendedor"}
                    footer={{
                        tiempoestimado: data[0].estado,
                        leyenda: data[0].creado,
                        duracion: data[0].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[0].control}
                    active={1 === Number(estado.pantallacompleta)}
                    value={0}
                    setValue={setValue}
                />
                <TimeLineTarget
                    icon={<ComputerIcon />}
                    title={"Cargar Pagare"}
                    subtitle={"Coordinador Credito"}
                    footer={{
                        tiempoestimado: data[1].estado,
                        leyenda: data[1].creado,
                        duracion: data[1].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[1].control}
                    active={2 === Number(estado.pantallacompleta)}
                    value={1}
                    setValue={setValue}
                />
                <TimeLineTarget
                    icon={<ComputerIcon />}
                    title={"Cargar Pagare EQUIP"}
                    subtitle={"Coordinador de credito"}
                    footer={{
                        tiempoestimado: data[2].estado,
                        leyenda: data[2].creado,
                        duracion: data[2].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[2].control}
                    active={3 === Number(estado.pantallacompleta)}
                    value={2}
                    setValue={setValue}
                />
                <TimeLineTarget
                    icon={<ComputerIcon />}
                    title={"Finalizar Solicitud"}
                    subtitle={"Coordinador Credito"}
                    footer={{
                        tiempoestimado: data[3].estado,
                        leyenda: data[3].creado,
                        duracion: data[3].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[3].control}
                    active={4 === Number(estado.pantallacompleta)}
                    value={3}
                    setValue={setValue}
                    endtarget={true}
                />
            </div>


            {mostrarCondicionado === false && (
                <AnalisisComentariosLine
                    tiempotranscurrido={estado.tiempotranscurrido}
                    tiempoestimado={estado.tiempoestimado}
                    comentarios={comentarios}
                />
            )}

        </PlantillaScreen>
    );
};
